<template>
  <div class="app flex-row align-items-center" v-if="session">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>{{ $t('resetPassword') }}</h1>

                <InputField name="password" type="password" :label="this.$t('password')" v-model="password" @error="fieldError"
                      :rules="{required:true, length: {min: 2}}"
                    />

                <InputField name="confirm_password" type="password" :label="this.$t('confirmPassword')" v-model="confirm_password" @error="fieldError"
                      :rules="{required:true, length: {min: 2}}"
                    />

                <b-button variant="success" @click="reset" block>{{ $t('reset') }}</b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Input from '@/components/form/Input'

export default {
  components: {
    InputField: Input
  },
  name: 'ProjectInvite',
  data: function() {
    return {
      password: "",
      confirm_password: "",
      session: null,
      errors: []
    }
  },
  methods: {
    fieldError(error) {
      let found = this.errors.find((i, e) => {
          return i.field == error.field
      })

      if (found === undefined) {
          this.errors.push(error)
      } else {
          this.errors.map(e => {
              if (found.field == e.field)
                  e.error = error.error
          })
      }
    },

    checkForErrors() {
      return this.errors.find((i, e) => {
          return i.error
      })
    },

    reset() {
      if (this.checkForErrors()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

        return
      }

      this.$http.post("/v1/user/resetpassword/" + this.$route.params.uuid, {password: this.password}).then(resp => {
          if (resp.status == 200) {
            this.$router.push({path: "/login"})

            return
          }

          if (resp.status == 400) {
            this.$bvModal.msgBoxOk(this.$t('registeredUser')).then(resp => {
              window.location.reload()
            })

            return
          }

          this.$bvModal.msgBoxOk(this.$t('badHappened'))
      }).catch(error => {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }

        this.$bvModal.msgBoxOk(error.response.data.message)
      })
    }
  },
  mounted() {
      this.$http.get("/v1/user/resetpassword/" + this.$route.params.uuid).then(resp => {
          if (resp.status == 400) {
              this.$router.push({path: "/login"})
              return
          }

          this.session = resp.data

      }).catch(error => {
        if (error.response.status == 500) {
          this.$serverErrorModal(error)
          return
        }

        this.$bvModal.msgBoxOk(error.response.data.message)
      })
  }
}
</script>
